/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-alert */
/* eslint-disable camelcase */
import { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { AuthDecorator } from '@components/auth-decorator';
import { actions } from '@state/modals';
import { RootState } from '@state/store';
import { Box, Button } from '@versumstudios/ui';

interface IActionOffersComponent {
  buyer: any;
  offer_id: number;
  price: number;
  token: any;
}

export const ActionOffersComponent: FC<IActionOffersComponent> = (props) => {
  const { buyer, offer_id, price, token } = props;
  const { contract, token_id } = token;

  const dispatch = useDispatch();
  const auth = useSelector((state: RootState) => state.auth);
  const viewer = auth.user?.id;
  const viewerIsBuyer = !!(viewer === buyer.user[0].user.id);
  const viewerIsHolder = !!token.holders.find((h: any) => h.holder_id === viewer);
  const viewerIsCreator = !!token.creators.find((c: any) =>
    c.wallet.user.find((e: any) => e.user.id === auth.account?.address)
  );

  const handleCancelSwap = () => {
    dispatch({ type: actions.MODALS_SET_MODAL, payload: { type: 'offer-cancel', offerId: offer_id } });
  };

  const handleAcceptOffer = () => {
    dispatch({
      type: actions.MODALS_SET_MODAL,
      payload: {
        type: 'offer-accept',
        id: offer_id,
        price,
        platformName: contract.name,
        tokenKT: contract.wallet?.address,
        tokenId: token_id,
      },
    });
  };

  return (
    <Box css={{ '&>*': { marginRight: '$space$4' } }}>
      {viewerIsBuyer && (
        <AuthDecorator onClick={handleCancelSwap}>
          <Button variant="market">Cancel offer</Button>
        </AuthDecorator>
      )}

      {(viewerIsHolder || viewerIsCreator) && (
        <AuthDecorator onClick={handleAcceptOffer}>
          <Button variant="market">Accept Offer</Button>
        </AuthDecorator>
      )}
    </Box>
  );
};
